import { useEffect, useState, Fragment, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useTranslations } from 'common/language'

import ModalWrapper from 'common/modals/ModalWrapper'
import ServiceReviews from 'common/widgets/blocks/ProductReviews/ServiceReviews'
import classNames from './styles.module.scss'
import modalClassnames from 'common/widgets/blocks/ProductReviews/styles.module.scss'


ScoreView.propTypes = {
  score: PropTypes.number,
  isVisible: PropTypes.bool,
  rating: PropTypes.number.isRequired,
  reviewCount: PropTypes.number.isRequired,
}

ScoreView.defaultProps = {
  isVisible: false,
  score: 98,
}

export default function ScoreView({ isVisible, score, rating, reviewCount }) {
  const [ count, setCount ] = useState(0)
  const [ show, setShow ] = useState(false)
  const showModal = useCallback(() => setShow(true), [])
  const hideModal = useCallback(() => setShow(false), [])
  useEffect(() => {
    if(isVisible && count < score) {
      setTimeout(_ => setCount(count + 1), 10)
    }
  }, [count, setCount, score, isVisible])
  const { gettext } = useTranslations()
  return (
    <Fragment>
      <div className={classNames.scoreContainer} onClick={showModal}>
        <div className={classNames.scoreBorder} />
        <div className={classNames.scoreContent}>
          <div className={classNames.score}>
            {isVisible && (count + '%')}
          </div>
          <div className={classNames.scoreText}>{gettext('of Happy \n Clients')}
            <button
              className={classNames.viewReviews}
            >
              {gettext('View reviews')}
            </button>
          </div>
        </div>
      </div>
      <ModalWrapper
        show={show}
        onHide={hideModal}
        component={ServiceReviews}
        rating={rating}
        reviewCount={reviewCount}
        maskClosable={false}
        title={gettext('Boa Lingua Reviews')}
        modalClassName={modalClassnames.serviceModal}
        key="modal-dialog"
        withTrigger
      />
    </Fragment>
  )
}
